import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { getRetailersById } from "../../../apis/retailers";

const VisitorsView = () => {
  const [formlist, setFormList] = useState<any>(null);
  const location = useLocation();

  useEffect(() => {
    // Get the query parameter from the URL
    const queryParams = new URLSearchParams(location.search);
    const rawData = queryParams.get("EmployeeData");

    // Parse JSON safely
    if (rawData) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(rawData));
        setFormList(parsedData);
      } catch (error) {
        console.error("Error parsing EmployeeData:", error);
      }
    }
  }, [location.search]);
  const [locationName, setLocationName] = useState<string>("");
  const { lat, lon } = JSON.parse(formlist?.allDetails?.geo_location || "{}") || {};

  useEffect(() => {
    if (formlist?.allDetails?.geo_location) {
      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`)
        .then((response) => response?.json())
        .then((data) => {
          if (data.display_name) {
            setLocationName(data?.display_name);
          } else {
            setLocationName("Location not found");
          }
        })
        .catch((error) => {
          console.error("Error fetching location:", error);
          setLocationName("Error fetching location");
        });
    }
  }, [formlist?.allDetails?.geo_location]);

  const openMap = (lat: any, lon: any) => {
    const url = `https://www.google.com/maps?q=${lat},${lon}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {formlist && (
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="container mt-5">
                  <h2>Visitors</h2>
                  <div className="row row">
                    <div className="mb-3  col-6">
                      <label htmlFor="name" className="form-label">
                        Full Name
                      </label>
                      <input type="text" className="form-control" value={formlist.allDetails?.name} required disabled />
                    </div>
                    <div className="mb-3  col-6">
                      <label htmlFor="rate" className="form-label">
                        Email
                      </label>
                      <input type="email" className="form-control" value={formlist.allDetails?.email} disabled />
                    </div>

                    {/* <div className="mb-3">
                      <label htmlFor="rate" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="phone_number"
                        value={formlist.allDetails?.email}
                        disabled
                      />
                    </div> */}
                  </div>
                  <div className="row">
                    {/* <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Type
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formlist.allDetails.type}
                        disabled
                      />
                    </div> */}
                    <div className="mb-3 col-6">
                      <label htmlFor="name" className="form-label">
                        Status
                      </label>
                      <input type="text" className="form-control" value={formlist.allDetails.status} disabled />
                    </div>
                    <div className="mb-3 col-6">
                      <label htmlFor="name" className="form-label">
                        Description
                      </label>
                      <input type="text" className="form-control" value={formlist.allDetails.description} disabled />
                    </div>
                    <div className="mb-3  col-6">
                      <label htmlFor="address" className="form-label">
                        Address
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          formlist?.allDetails?.address
                            ? `${formlist?.allDetails?.address?.addressLine}, ${formlist?.allDetails?.address?.city},${formlist?.allDetails?.address?.states},${formlist?.allDetails?.address?.country},${formlist?.allDetails?.address?.pincode} `
                            : "N/A"
                        }
                        disabled
                      />
                    </div>
                    <div className="mb-3 col-6">
                      <label htmlFor="address" className="form-label">
                        latitude
                      </label>
                      <input type="text" className="form-control" value={lat} disabled />
                    </div>
                    <div className="mb-3 col-6">
                      <label htmlFor="address" className="form-label">
                        longitude
                      </label>
                      <input type="text" className="form-control" value={lon} disabled />
                    </div>
                    <div className="mb-3 col-6">
                      <label htmlFor="googleMap" className="form-label d-flex align-items-center ">
                        <span style={{ marginRight: 25 }}>Google Map</span>
                        <i
                          className="fa fa-map-marker-alt text-primary"
                          style={{ cursor: "pointer", fontSize: "2.2rem" }}
                          onClick={() => openMap(lat, lon)}
                          title="Open in Google Maps"
                        ></i>
                      </label>
                    </div>
                    <div className="mb-3  col-6">
                      <label htmlFor="name" className="form-label">
                        GEO location
                      </label>
                      <input type="text" className="form-control" value={locationName} disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VisitorsView;
